import { Injectable } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Router } from '@angular/router';
import { Observable, Subject, throwError, of, EMPTY } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators'

import { UserInfoService } from '../http/user-info.service'
import { SecureStorageService } from '../utilities/secure-storage.service'
import { AppSettings } from '../../configs/app-settings.config'
import { AppMetadataHandler } from '../../configs/app-metadata.handler'
import { AppConfig } from '../../configs/app.config';
import { environment } from '../../../../environments/environment'
import * as moment from 'moment';
import { Md5 } from 'ts-md5/dist/md5';

/* NG Zorro Messaging Service used: Change for production */
import { NzMessageService } from 'ng-zorro-antd/message';
import { GlobalErrorHandler } from '../services/global-error-handler/global-error-handler.service';
import { ArrayManipulations } from '../utilities/arrayManipulations';
@Injectable()

export class ApiRequestService {

    public downloadQuotationAPI = "quotationContainer/downloadQuotationPdf"
    public token: string;
    public httpHeader: Headers;
    public options: RequestOptions;
    public lastAPICallTime: any;


    constructor(
        private appConfig: AppConfig,
        private http: Http,
        private router: Router,
        private userInfoService: UserInfoService,
        private appSettings: AppSettings,
        public msg: NzMessageService,
        private arrayManipulations: ArrayManipulations,
        public appMetadataHandler: AppMetadataHandler,
        private globalErrorHandler: GlobalErrorHandler,
        private secureStorageService: SecureStorageService
    ) {
        this.httpHeader = new Headers({ headers: { 'Content-type': 'application/json' } });
    }


    appendFormHeaderForMultipartNew(hash?: any): any {
        const headers = {
            'applicationId': environment.applicationId,
            'hash': '123'
        };
        if (this.token !== null) {
            headers['Authorization'] = this.token;
        }
        return headers;
    }

    appendFormHeader(hash?: any): Headers {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append("applicationId", environment.applicationId);
        headers.append("source", environment.applicationSource);
        if (hash != null) {
            headers.append("hash", hash);
        }
        let token = this.token;
        if (token !== null) {
            headers.append("Authorization", token);
        }
        return headers;
    }

    /**
     * Stores and tracks API URL call counts in secure storage
     * This method keeps a record of how many times each URL endpoint is called
     * by incrementing a counter for each URL in the secure storage
     * 
     * @param url The API endpoint URL to track
     */
    StoreTheUrlCall(url) {
        let parsedURLSLS = {};
        
        try {
            // Get existing data and safely parse it
            const urlSLS = this.secureStorageService.get('URLSLS');
            if (urlSLS) {
                parsedURLSLS = JSON.parse(urlSLS) || {};
            }
        } catch (error) {
            console.warn('Error parsing URL storage:', error);
            // Reset storage to fix corruption
            this.secureStorageService.remove('URLSLS');
        }
        
        // Update the count for the current URL
        parsedURLSLS[url] = (parsedURLSLS[url] || 0) + 1;
        
        // Safely store the updated data
        try {
            this.secureStorageService.set('URLSLS', JSON.stringify(parsedURLSLS));
        } catch (error) {
            console.error('Error storing URL data:', error);
        }
    }

    /**
     * This is a Global place to define all the Request Headers that must be sent for every ajax call
     */
    getRequestOptions(requestMethod, url: string, urlParam?: URLSearchParams, body?: Object, exception?: any, withoutServerContext?): RequestOptions {
        const currentTimeStamp = moment();
        const idleTime = currentTimeStamp.diff(this.lastAPICallTime, "minutes");
        
        if (exception || idleTime < this.appSettings.sessionTimeoutInMinutes) {
            let header = null;
            
            if (body != null && body != undefined) {
                const hash = Md5.hashStr(JSON.stringify(body).replace(/\r?\n|\r/g, "").replace(/\s+/g, ""));
                header = this.appendFormHeader(hash);
            } else {
                header = this.appendFormHeader(null);
            }
            
            const baseApiPath = withoutServerContext ? this.appConfig.baseApiPathWithoutContext : this.appConfig.baseApiPath;
            url = baseApiPath + url;
            
            let options = new RequestOptions({
                headers: header,
                method: requestMethod,
                url: url,
                body: body
            });
            
            if (urlParam) {
                options = options.merge({ params: urlParam });
            }
            
            this.StoreTheUrlCall(url);
            return options;
        } else {
            return null;
        }
    }

    getRequestOptionsForMultipart(requestMethod, url: string, urlParam?: URLSearchParams, body?: Object): RequestOptions {
        var header = null;
        header = this.appendFormHeaderForMultipartNew(null);
        if (!environment.production) {
            url = url
        } else {
            if (!this.appMetadataHandler.featureFlags.enableAPIMapper)
                url = this.appConfig.baseApiPath + url
            else
                url = this.appConfig.baseApiPath + this.APIEndpointMap[url]
        }
        let options = new RequestOptions({
            headers: header,
            method: requestMethod,
            url: url,
            body: body

        });
        if (urlParam) {
            options = options.merge({ params: urlParam });
        }
        return options;
    }

    /**
     * Performs an HTTP GET request to the specified URL
     * @param url The endpoint URL to call
     * @param urlParams Optional query parameters
     * @param withoutServerContext Optional flag to use API path without server context
     * @param status Optional status flag
     * @returns Observable with the response data
     */
    get(url: string, urlParams?: URLSearchParams, withoutServerContext?, status?: boolean): Observable<any> {
        const requestOptions = this.getRequestOptions(0, url, urlParams, undefined, false, withoutServerContext);
        
        if (requestOptions != null) {
            return this.http.get(url, requestOptions)
                .pipe(
                    map((resp: any) => {
                        this.lastAPICallTime = moment();
                        if (typeof resp._body === 'string' && resp._body.includes('<html')) {
                            this.leaveApplication();
                        }
                        return resp ? this.globalErrorHandler.sanitizeJSONResp(resp) : resp;
                    }),
                    catchError((error: any) => {
                        console.log("http error:", error);
                        if (error.status === 401 || error.status === 403) {
                            this.router.navigate(['/logout']);
                        }

                        if (this.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                            this.globalErrorHandler.redirectOnServerError(error.status);
                        }

                        return of(this.globalErrorHandler.logFailedAPI(error, url));
                    })
                );
        } else {
            this.logout();
            this.leaveApplication();
            return EMPTY;
        }
    }

    APIerrorMap = {}
    /**
     * Performs an HTTP GET request using API mapper to resolve the endpoint URL
     * @param url The service code or endpoint identifier
     * @param urlParams Optional query parameters
     * @param withoutServerContext Optional flag to use API path without server context
     * @param pathVariables Optional path variables to be replaced in the URL
     * @param allowSensitiveHTML Optional flag to allow HTML content in response
     * @returns Observable with the response data
     */
    getCallWithAPIMapper(url: string, urlParams?: URLSearchParams, withoutServerContext?, pathVariables?, allowSensitiveHTML?): Observable<any> {
        const revisedURL = this.mapperUtil('get', url, pathVariables);
        const requestOptions = this.getRequestOptions(RequestMethod.Get, revisedURL, urlParams, undefined, false, withoutServerContext);
        
        if (requestOptions != null) {
            return this.http.get(revisedURL, requestOptions)
                .pipe(
                    map((resp: any) => {
                        this.lastAPICallTime = moment();
                        if (typeof resp._body === 'string' && resp._body.includes('<html') && !allowSensitiveHTML) {
                            this.leaveApplication();
                        }
                        return resp ? this.globalErrorHandler.sanitizeJSONResp(resp) : resp;
                    }),
                   catchError(error => this.handleError(error))
                );
        } else {
            this.logout();
            this.leaveApplication();
            return EMPTY;
        }
    }

    
   /**
    * Performs an HTTP POST request to the specified URL
    * @param url The endpoint URL
    * @param body The request body
    * @returns Observable with the response data
    */
   post(url: string, body: Object): Observable<any> {
        let me = this;
        let requestOptions = this.getRequestOptions(RequestMethod.Post, url, undefined, body, false);
        if (requestOptions != null) {
            return this.http.request(new Request(requestOptions))
                .pipe(map((resp: any) => {
                    this.lastAPICallTime = moment()

                    if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                        this.leaveApplication();
                    }
                    if (url == '/login') {
                        this.token = resp.headers.get('authorization');
                    }
                    if (resp)
                        return this.globalErrorHandler.sanitizeJSONResp(resp)
                    else
                        return resp
                }),
                catchError(function (error: any) {
                    if (error.status === 401) {
                        me.router.navigate(['/logout']);
                    }
                    else if (error.status === 500) {
                        var jsonBody = error._body;
                    }

                    if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                        me.globalErrorHandler.redirectOnServerError(error.status)
                    }
                    return of(me.globalErrorHandler.logFailedAPI(error, url))
                }));
        }
        else {
            this.logout();
            this.leaveApplication();
            return EMPTY;
        }
    }

    /**
     * Performs an HTTP POST request using API mapper to resolve the endpoint URL
     * @param url The service code or endpoint identifier
     * @param body The request body
     * @returns Observable with the response data
     */
    postCallWithAPIMapper(url: string, body: Object): Observable<any> {
        let me = this;
        let revisedURL = this.mapperUtil('post', url)
        let requestOptions = this.getRequestOptions(RequestMethod.Post, revisedURL, undefined, body, false);
        if (requestOptions != null) {
            return this.http.request(new Request(requestOptions))
                .pipe(map((resp: any) => {
                    this.lastAPICallTime = moment()
                    if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                        this.leaveApplication();
                    }
                    if (url == '/login') {
                        this.token = resp.headers.get('authorization');
                    }
                    if (resp)
                        return this.globalErrorHandler.sanitizeJSONResp(resp)
                    else
                        return resp
                }),
                catchError(function (error: any) {
                    if (error.status === 401 || error.status == 403 || error.status === 504) {
                        me.logout()
                    }
                    
                    if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                        me.globalErrorHandler.redirectOnServerError(error.status)
                    }
                    
                    return of(me.globalErrorHandler.logFailedAPI(error, url))
                }));
        }
        else {
            this.logout();
            this.leaveApplication();
            return EMPTY;
        }
    }

    /**
     * Performs an HTTP POST request with multipart form data
     * @param url The endpoint URL
     * @param body The multipart form data
     * @returns Observable with the response data
     */
    postForMultipart(url: string, body: Object): Observable<any> {
        let me = this;
        let requestOptions = this.getRequestOptionsForMultipart(RequestMethod.Post, url, undefined, body);
        return this.http.request(new Request(requestOptions))
            .pipe(map((resp: any) => {
                if (typeof resp._body == 'string' && resp._body.includes('<html')) {
                    this.leaveApplication();
                }
                if (url == '/login') {
                    this.token = resp.headers.get('authorization');
                }
                return resp;
            }),
            catchError(function (error: any) {
                if (error.status === 401) {
                    me.router.navigate(['/logout']);
                }
                else if (error.status === 500) {
                    var jsonBody = error._body;
                }

                if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                    me.globalErrorHandler.redirectOnServerError(error.status)
                }
                return of(me.globalErrorHandler.logFailedAPI(error, url))
            }));
    }

    /**
     * Maps service codes to actual API endpoints
     * @param type The HTTP method type ('get' or 'post')
     * @param serviceCd The service code to map
     * @param pathVariables Optional path variables to replace in the URL
     * @returns The mapped endpoint URL
     */
    replacedServiceCdMap = {}
    mapperUtil(type, serviceCd, pathVariables?) {
        let url;
        let newServiceCd
     
        if (type == 'post') {
            if(serviceCd.includes('/')) {
                newServiceCd = serviceCd.replace(/\/$/, '');
                if (newServiceCd.includes('/')) {
                    let urlWithQueryParams = this.arrayManipulations.splitMulti(newServiceCd, ['/']);
                    let queryParam = urlWithQueryParams.pop();
                    if (this.arrayManipulations.isArrayIterable(urlWithQueryParams) && this.arrayManipulations.isArrayIterable(urlWithQueryParams)) {
                        newServiceCd = urlWithQueryParams + "/"
                        urlWithQueryParams.length > 1 && console.warn(newServiceCd)
                        url = (this.APIEndpointMap[newServiceCd] || this.APIEndpointMap[newServiceCd.slice(0, -1)]) + "/" + queryParam
                    }
                }
            }
            else
              newServiceCd = serviceCd
            if(!url && this.APIEndpointMap[newServiceCd]){
                url = this.APIEndpointMap[newServiceCd]
            }else{
                if(environment['showAPIConfigError']) 
                alert("post URL not present in- "+ serviceCd)
            }
        } else if (type == 'get' && !pathVariables) {
            let urlWithQueryParams = serviceCd
            if (serviceCd.includes('/')) {
                urlWithQueryParams = this.arrayManipulations.splitMulti(serviceCd, ['/'])
                if (urlWithQueryParams.length <= 2) {
                    let queryParam = urlWithQueryParams.pop()
                    if (this.arrayManipulations.isArrayIterable(urlWithQueryParams) && this.arrayManipulations.isArrayIterable(urlWithQueryParams)) {
                        newServiceCd = urlWithQueryParams + "/"
                        urlWithQueryParams.length > 1 && console.warn(newServiceCd)
                        url = (this.APIEndpointMap[newServiceCd] || this.APIEndpointMap[newServiceCd.slice(0, -1)]) + "/" + queryParam
                    }
                }
                else {
                    let newServiceCd = urlWithQueryParams.shift();
                    url = (this.APIEndpointMap[newServiceCd] || this.APIEndpointMap[newServiceCd.slice(0, -1)]);
                    url = this.replaceEndpointArgs(url, urlWithQueryParams);
                }
            } else {
                url = this.APIEndpointMap[urlWithQueryParams]
            }
            
        } else if (pathVariables) {
            url = this.handlePathVariables(pathVariables, serviceCd)
        } else{
            if(environment['showAPIConfigError']) 
            alert("get URL not present in- "+ serviceCd)
        }
        this.replacedServiceCdMap[serviceCd] = url
        localStorage.setItem("replacedServiceCd", JSON.stringify(this.replacedServiceCdMap))
        if(url) url = url.replaceAll("//", "/")
        return url
    }

   

    handlePathVariables(pathVarables, serviceCd) {
        let urlWithPathRefs = this.APIEndpointMap && this.APIEndpointMap[serviceCd]? this.APIEndpointMap[serviceCd] : ""
        let urlArray = urlWithPathRefs.split("/")
        let num = 0
        let finalURLArray = this.arrayManipulations.deepCopy(urlArray)
        let finalURL;
        if (this.arrayManipulations.isArrayIterable(pathVarables) && this.arrayManipulations.isArrayIterable(urlArray)) {
            urlArray.forEach((ele, i) => {
                if (ele.includes("$")) {
                    finalURLArray[i] = pathVarables[num]
                    num++
                }
            })
        }
        finalURL = num == 0 ? urlWithPathRefs : finalURLArray.join("/")
        return finalURL
    }

    replaceEndpointArgs(url, args) {
        if (typeof url === 'string' && this.arrayManipulations.isArrayIterable(args)) {
            for (let arg of args) {
                if (typeof arg === 'string') url = url.replace('${}', arg);
            }
        }
        return url;
    }

    /**
     * Performs an HTTP PUT request to the specified URL
     * @param url The endpoint URL
     * @param body The request body
     * @returns Observable with the response data
     */
    put(url: string, body: Object): Observable<any> {
        let me = this;
        let requestOptions = this.getRequestOptions(RequestMethod.Put, url, undefined, body, false);
        if (requestOptions != null) {
            return this.http.request(new Request(requestOptions))
                .pipe(
                    map((resp: any) => {
                        this.lastAPICallTime = moment();
                        if (typeof resp._body === 'string' && resp._body.includes('<html')) {
                            this.leaveApplication();
                        }
                        return resp ? this.globalErrorHandler.sanitizeJSONResp(resp) : resp;
                    }),
                    catchError((error: any) => {
                        if (error.status === 401) {
                            me.router.navigate(['/logout']);
                        }

                        if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                            me.globalErrorHandler.redirectOnServerError(error.status);
                        }
                        return of(me.globalErrorHandler.logFailedAPI(error, url));
                    })
                );
        } else {
            this.logout();
            this.leaveApplication();
            return EMPTY;
        }
    }

    /**
     * Performs an HTTP DELETE request to the specified URL
     * @param url The endpoint URL
     * @returns Observable with the response data
     */
    delete(url: string): Observable<any> {
        let me = this;
        let requestOptions = this.getRequestOptions(RequestMethod.Delete, url, undefined, undefined, false);
        if (requestOptions != null) {
            return this.http.request(new Request(requestOptions))
                .pipe(
                    map((resp: any) => {
                        this.lastAPICallTime = moment();
                        if (typeof resp._body === 'string' && resp._body.includes('<html')) {
                            this.leaveApplication();
                        }
                        return resp ? this.globalErrorHandler.sanitizeJSONResp(resp) : resp;
                    }),
                    catchError((error: any) => {
                        if (error.status === 401) {
                            me.router.navigate(['/logout']);
                        }

                        if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                            me.globalErrorHandler.redirectOnServerError(error.status);
                        }
                        return of(me.globalErrorHandler.logFailedAPI(error, url));
                    })
                );
        } else {
            this.logout();
            this.leaveApplication();
            return EMPTY;
        }
    }

    logout() {
        this.logoutAgentCallMethod('user-service/logout').subscribe(jsonResp => {
            localStorage.clear();
            sessionStorage.clear();
            this.userInfoService.removeUserInfo();
            this.router.navigate(['/login']);
        });
    }

    APIMap = {}
    APIEndpointMap = {}
    APIMasterResponse = []
    getAPIMaster() {
        let serviceURL = 'user-service/api/fetchAPIByApplicationCd/NBU'
        if (environment['APIMasterEndpoint']) serviceURL = environment['APIMasterEndpoint']
        return this.get(serviceURL).pipe(
            tap(jsonResp => {
                this.APIMasterResponse = jsonResp
                if (jsonResp && Array.isArray(jsonResp) && jsonResp.length > 0) {
                    jsonResp.forEach(serviceDO => {
                        this.APIMap[serviceDO.serviceCd] = serviceDO
                        this.APIEndpointMap[serviceDO.serviceCd] = serviceDO.contextURL + '/' + serviceDO.endPointURL
                    })
                }
            }),
            catchError(error => {
                console.error('Error fetching API Master:', error);
                return of(null);
            })
        );
    }


    /**
     * Authenticates a user by sending login credentials to the server
     * @param url The endpoint URL (will be overridden with user-service/login)
     * @param body The request body containing login credentials
     * @returns Observable with the authentication response
     */
    authenticate(url: string, body: Object): Observable<any> {
        // Override URL with the standard login endpoint regardless of input
        url = 'user-service/login';
        
        const me = this;
        this.lastAPICallTime = moment();
        const requestOptions = this.getRequestOptions(RequestMethod.Post, url, undefined, body);
        
        return this.http.request(new Request(requestOptions))
            .pipe(
                map((resp: any) => {
                    this.lastAPICallTime = moment();
                    
                    // Check for HTML response which indicates session issues
                    if (typeof resp._body === 'string' && resp._body.includes('<html')) {
                        this.leaveApplication();
                    }
                    
                    // Store authorization token if token mode is enabled
                    if (environment.tokenMode) {
                        this.token = resp.headers.get('authorization');
                    }
                    
                    return resp ? this.globalErrorHandler.sanitizeJSONResp(resp) : resp;
                }),
                catchError((error: any) => {
                    // Handle unauthorized access
                    if (error.status === 401) {
                        me.router.navigate(['/logout']);
                    }
                    
                    // Handle server errors with redirect if configured
                    if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                        me.globalErrorHandler.redirectOnServerError(error.status);
                    }
                    
                    // Display error message if available
                    if (error.statusText) {
                        me.msg.error(error.statusText);
                    }
                    
                    return of(me.globalErrorHandler.logFailedAPI(error, url));
                })
            );
    }

    /**
     * Performs an HTTP GET request with complex object parameters converted to query string
     * @param url The endpoint URL or service code
     * @param param The complex object to be converted to query parameters
     * @returns Observable with the response data
     */
    getServiceWithComplexObjectAsQueryString(url: string, param: any): Observable<any> {
        const endpoint = url;
        
        // Determine the full URL based on API mapper configuration
        if (!this.appMetadataHandler.featureFlags.enableAPIMapper) {
            url = this.appConfig.baseApiPath + url;
        } else {
            url = this.appConfig.baseApiPath + this.APIEndpointMap[url];
        }
        
        // Convert object properties to URL parameters
        const params: URLSearchParams = new URLSearchParams();
        for (const key in param) {
            if (param.hasOwnProperty(key)) {
                const val = param[key];
                // Special handling for userId in changePassword endpoint
                if (endpoint === 'changePassword' && key === 'userId') {
                    params.set(key, val);
                } else {
                    params.set(key, encodeURIComponent(val));
                }
            }
        }
        
        this.options = new RequestOptions({ headers: this.httpHeader, params: params });
        
        return this.http
            .get(url, this.options)
            .pipe(
                map(this.extractData),
                catchError(this.handleError)
            );
    }

    /**
     * Extracts JSON data from HTTP response
     * @param res The HTTP response
     * @returns The parsed JSON body or empty object
     */
    private extractData(res: Response) {
        const body = res.json();
        return body || {};
    }

    /**
     * Handles HTTP errors and formats error messages
     * @param error The error object
     * @returns Observable that throws the formatted error message
     */
    private handleError(error: any) {
        const errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        return throwError(errMsg);
    }

    /**
     * Performs a logout request with special handling for session timeout
     * @param url The logout endpoint URL
     * @param urlParams Optional query parameters
     * @returns Observable with the response data
     */
    logoutAgentCallMethod(url: string, urlParams?: URLSearchParams): Observable<any> {
        const me = this;
        const idleTimeException = true;
        const requestOptions = this.getRequestOptions(RequestMethod.Get, url, urlParams, undefined, idleTimeException);
        
        return this.http.request(new Request(requestOptions))
            .pipe(
                map((resp: any) => {
                    this.lastAPICallTime = moment();
                    
                    // Check for HTML response which indicates session issues
                    if (typeof resp._body === 'string' && resp._body.includes('<html')) {
                        this.leaveApplication();
                    }
                    
                    return resp ? this.globalErrorHandler.sanitizeJSONResp(resp) : resp;
                }),
                catchError((error: any) => {
                    // Handle unauthorized or forbidden access
                    if (error.status === 401 || error.status === 403) {
                        me.router.navigate(['/logout']);
                    }

                    // Handle server errors with redirect if configured
                    if (me.appMetadataHandler.featureFlags.redirectOnServerErrors) {
                        me.globalErrorHandler.redirectOnServerError(error.status);
                    }
                    
                    return of(me.globalErrorHandler.logFailedAPI(error, url));
                })
            );
    }

    msgID
    leaveApplication() {
        if (!this.msgID) {
            this.msgID = this.msg.error("Session has expired. Logging out . . .").messageId;
            this.router.navigate([{ outlets: { modal: null } }]);
            localStorage.clear();
            sessionStorage.clear();
            this.userInfoService.removeUserInfo();
            this.router.navigate(['/login']);
        }
    }

    resetSessionExpiredMsgID() {
        this.msgID = null
    }

}
